import React from "react";
import { CheckCircle2 } from "lucide-react";

export const About = () => {
  const values = [
    "Quality Work",
    "Reliability",
    "Professional Service",
    "Customer Satisfaction",
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* VIDEO SIDE 🔥 */}
            <div className="relative">
              <div className="relative z-10">
                <video
                  src="/img/vid1.mp4"
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="rounded-lg shadow-2xl w-full h-[500px] object-cover"
                />
              </div>

              <div className="absolute -bottom-6 -right-6 w-full h-full bg-green-500/20 rounded-lg -z-0"></div>
            </div>

            {/* Content Side */}
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
                About{" "}
                <span className="text-green-600">Samaniega's Landscaping</span>
              </h2>

              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Samaniega's Landscaping LLC is dedicated to providing
                high-quality landscaping services for residential and commercial
                properties. With a commitment to craftsmanship, reliability, and
                customer satisfaction, we transform outdoor spaces into
                beautiful and functional landscapes.
              </p>

              <div className="mb-6">
                <p className="text-lg text-gray-700">
                  <span className="font-semibold text-black">Owner:</span>{" "}
                  Miguel Soltero
                </p>
              </div>

              <div className="space-y-3 mb-8">
                <h3 className="text-xl font-bold text-black mb-4">
                  Our Core Values:
                </h3>
                {values.map((value, index) => (
                  <div
                    key={index}
                    className="flex items-center space-x-3 group"
                  >
                    <div className="flex-shrink-0 w-8 h-8 rounded-full bg-green-500 flex items-center justify-center group-hover:scale-110 transition-transform">
                      <CheckCircle2 className="h-5 w-5 text-black" />
                    </div>
                    <span className="text-lg text-gray-700 font-medium">
                      {value}
                    </span>
                  </div>
                ))}
              </div>

              <div className="bg-green-50 border-l-4 border-green-500 p-6 rounded-r-lg">
                <p className="text-gray-700 italic">
                  "We don't just create landscapes – we create outdoor
                  experiences that bring joy and value to your property for
                  years to come."
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
